<body>



  <div class="main-wrapper">
    <div class="main-content">
      <header>

        <div class="head-line">

          <p>Reports</p>


        </div>
        <div class="user-wrapper">
          <p>{{storedData.agencyRefId.agencyName}}</p>

          <div>
            <img class="log1"
              [src]="this.storedData.agencyRefId.logo?this.storedData.agencyRefId.logo:'../../../../assets/../../assets/images/user1.jpeg'">
          </div>
        </div>
      </header>

      <main class="main-2">

        <div class="container">
          <div class="projects">


            <div class="two-screen">
              <!---sec sidebar-->



              <!---------------->
              <div class="card2">
                <div class="card" [ngClass]="{'selected': selectedCard === 'Perfomance MIS'}"
                  (click)="selectCard('Perfomance MIS')">
                  <p class="card-title">Perfomance MIS</p>
                  <!-- <p class="card-text">Get insights into staff Perfomance MIS.</p> -->
                </div>


                <div class="card" [ngClass]="{'selected': selectedCard === 'Data MIS'}"
                  (click)="selectCard('Data MIS');type='Data MIS'">
                  <p class="card-title">Data MIS</p>
                  <!-- <p class="card-text">Get insights into staff Perfomance MIS.</p> -->
                </div>


                <div class="card" [ngClass]="{'selected': selectedCard === 'Contact MIS'}"
                  (click)="selectCard('Contact MIS');type='Contact MIS'">
                  <p class="card-title">Contact MIS</p>
                  <!-- <p class="card-text">Get insights into staff Perfomance MIS.</p> -->
                </div>

                <div class="card" [ngClass]="{'selected': selectedCard === 'ClientEmail MIS'}"
                  (click)="selectCard('ClientEmail MIS');type='ClientEmail MIS'">
                  <p class="card-title">Client Email MIS</p>
                  <!-- <p class="card-text">Get insights into staff Perfomance MIS.</p> -->
                </div>

                <div class="card" [ngClass]="{'selected': selectedCard === 'Live MIS'}"
                  (click)="selectCard('Live MIS');type='Live MIS'">
                  <p class="card-title">Live MIS</p>
                  <!-- <p class="card-text">Get insights into staff Perfomance MIS.</p> -->
                </div>


                <div class="card" [ngClass]="{'selected': selectedCard === 'Call Status MIS'}"
                  (click)="selectCard('Call Status MIS');type='Call Status MIS'">
                  <p class="card-title">Call Status MIS</p>
                  <!-- <p class="card-text">Get insights into staff Perfomance MIS.</p> -->
                </div>

                <div class="card" [ngClass]="{'selected': selectedCard === 'Call Performance MIS'}"
                  (click)="selectCard('Call Performance MIS');type='Call Performance MIS'">
                  <p class="card-title">Call Performance MIS</p>
                  <!-- <p class="card-text">Get insights into staff Perfomance MIS.</p> -->
                </div>

                <div class="card" [ngClass]="{'selected': selectedCard === 'Email Count MIS'}"
                  (click)="selectCard('Email Count MIS');type='Email Count MIS'">
                  <p class="card-title">Email Count MIS</p>
                  <!-- <p class="card-text">Get insights into staff Perfomance MIS.</p> -->
                </div>
              </div>


              <div class="second-side">
                <p class="table-heading">{{selectedCard}}</p>

                <form class="staff-form mt-2" *ngIf="selectedCard === 'Perfomance MIS'">
                  <div class="row">
                    <div class="col-lg-12 col-xs-12 col-sm-6">
                      <div class="form-group">
                        <!-- <label>Perfomance Report</label> -->
                        <!-- <select class="select-al"    [ngModelOptions]="{standalone: true}" 
                                                [(ngModel)]="status">
                                                  <option value="teleCallerPerfomance MISReport">TeleCaller Perfomance</option>
                                                  <option value="Perfomance MISReport">Perfomance Report</option>
                                                 </select> -->
                      </div>

                      <div class="form-group">
                        <label>User Types </label>
                        <select class="select-al" [ngModelOptions]="{standalone: true}" [(ngModel)]="usertype">
                          <option *ngFor="let option of userTypes" [ngValue]="option">{{ option.userType }}</option>
                        </select>
                      </div>

                      <!-- Select Status Dropdown -->
                      <div class="form-group">
                        <label>Select Status</label>
                        <select class="select-al" [ngModelOptions]="{standalone: true}" [(ngModel)]="status">
                          <option disabled selected>Please select </option>
                          <option
                            *ngIf="usertype && usertype.userType === 'Backend Staff'||usertype && usertype.userType === 'Field Executive'"
                            [ngValue]="'initiated'">Initiated</option>
                          <option *ngIf="usertype && usertype.userType === 'Backend Staff'" [ngValue]="'Verified'">
                            Verified</option>

                          <option *ngIf="usertype && usertype.userType === 'Tele Caller'" [ngValue]="'interested'">
                            Interested</option>
                          <option *ngIf="usertype && usertype.userType === 'Tele Caller'" [ngValue]="'telecall'">Tele
                            Call</option>

                        </select>

                      </div>
                    </div>
                    <div class="col-lg-12 col-xs-12 col-sm-6">
                      <div class="form-group">
                        <label>From Date*</label>
                        <input type="date" [ngModelOptions]="{standalone: true}" [(ngModel)]="fromDate"
                          class="form-control" placeholder="Type here">
                      </div>
                      <div class="form-group">
                        <label>To Date*</label>
                        <input type="date" [ngModelOptions]="{standalone: true}" [(ngModel)]="toDate"
                          class="form-control" placeholder="Type here">
                      </div>
                    </div>
                    <!-- <div class="col-lg-12 col-xs-12 col-sm-6">
                                            <div class="form-group">
                                              <label>Email ID*</label>
                                              <input type="text" class="form-control" placeholder="Type here">
                                            </div>
                                            </div> -->
                  </div>
                  <div class="content mt-1">
                    <!-- <button class="add-n">Add New Email ID</button> -->
                    <button class="btn-two" (click)="report()">Download</button>
                  </div>
                </form>

                <form class="staff-form mt-2" *ngIf="selectedCard === 'Data MIS'">
                  <div class="row">
                    <div class="col-lg-12 col-xs-12 col-sm-6">

                      <div class="form-group">
                        <label>Select Status</label>
                        <select class="select-al" [ngModelOptions]="{standalone: true}" [(ngModel)]="status">
                          <option disabled selected>Please select </option>
                          <option [ngValue]="'Not Interested'">Not Interested</option>
                          <option [ngValue]="'Client Enrolled'">Client Enrolled</option>
                          <option [ngValue]="'Under Validation'">Under Validation</option>
                          <option [ngValue]="'Verified'">Verified</option>
                          <option [ngValue]="'Under TeleCall'">Under TeleCall</option>
                          <option [ngValue]="'New case'">New case</option>



                          <option [ngValue]="'Disabled'">Disabled</option>
                          <option [ngValue]="'Demo'">Demo</option>
                          <option [ngValue]="'Proposal Sent'">Proposal Sent</option>


                        </select>

                      </div>
                    </div>
                    <div class="col-lg-12 col-xs-12 col-sm-6">
                      <div class="form-group">
                        <label>From Date*</label>
                        <input type="date" [ngModelOptions]="{standalone: true}" [(ngModel)]="fromDate"
                          class="form-control" placeholder="Type here">
                      </div>
                      <div class="form-group">
                        <label>To Date*</label>
                        <input type="date" [ngModelOptions]="{standalone: true}" [(ngModel)]="toDate"
                          class="form-control" placeholder="Type here">
                      </div>
                    </div>
                    <!-- <div class="col-lg-12 col-xs-12 col-sm-6">
                                                        <div class="form-group">
                                                          <label>Email ID*</label>
                                                          <input type="text" class="form-control" placeholder="Type here">
                                                        </div>
                                                        </div> -->
                  </div>
                  <div class="content mt-1">
                    <!-- <button class="add-n">Add New Email ID</button> -->
                    <button class="btn-two" (click)="DataMISReport()">Download</button>
                  </div>
                </form>

                <form class="staff-form mt-2" *ngIf="selectedCard === 'Contact MIS'">


                  <div class="col-lg-12 col-xs-12 col-sm-6">
                    <div class="form-group">
                      <label>From Date*</label>
                      <input type="date" [ngModelOptions]="{standalone: true}" [(ngModel)]="fromDate"
                        class="form-control" placeholder="Type here">
                    </div>
                    <div class="form-group">
                      <label>To Date*</label>
                      <input type="date" [ngModelOptions]="{standalone: true}" [(ngModel)]="toDate" class="form-control"
                        placeholder="Type here">
                    </div>
                  </div>

                  <div class="content mt-1">
                    <!-- <button class="add-n">Add New Email ID</button> -->
                    <button class="btn-two" (click)="DataMISReport()">Download</button>
                  </div>
                </form>




                <form class="staff-form mt-2" *ngIf="selectedCard === 'ClientEmail MIS'">


                  <div class="col-lg-12 col-xs-12 col-sm-6">
                    <div class="form-group">
                      <label>From Date*</label>
                      <input type="date" [ngModelOptions]="{standalone: true}" [(ngModel)]="fromDate"
                        class="form-control" placeholder="Type here">
                    </div>
                    <div class="form-group">
                      <label>To Date*</label>
                      <input type="date" [ngModelOptions]="{standalone: true}" [(ngModel)]="toDate" class="form-control"
                        placeholder="Type here">
                    </div>
                  </div>

                  <div class="content mt-1">
                    <!-- <button class="add-n">Add New Email ID</button> -->
                    <button class="btn-two" (click)="DataMISReport()">Download</button>
                  </div>
                </form>




                <form class="staff-form mt-2" *ngIf="selectedCard === 'Live MIS'">




                  <div class="content mt-1">
                    <!-- <button class="add-n">Add New Email ID</button> -->
                    <button class="btn-two" (click)="DataMISReport()">Download</button>
                  </div>
                </form>






                <form class="staff-form mt-2" *ngIf="selectedCard === 'Call Status MIS'">


                  <div class="col-lg-12 col-xs-12 col-sm-6">

                    <div class="form-group">
                      <label>Telle Callers*</label>

                      <ng-multiselect-dropdown [settings]="dropdownSettings" [ngModelOptions]="{standalone: true}"
                        [(ngModel)]="selectedTellecallers" [data]="telleCallers">
                      </ng-multiselect-dropdown>


                    </div>









                    <div class="form-group">
                      <label>From Date*</label>
                      <input type="date" [ngModelOptions]="{standalone: true}" [(ngModel)]="fromDate"
                        class="form-control" placeholder="Type here">
                    </div>
                    <div class="form-group">
                      <label>To Date*</label>
                      <input type="date" [ngModelOptions]="{standalone: true}" [(ngModel)]="toDate" class="form-control"
                        placeholder="Type here">
                    </div>
                  </div>

                  <div class="content mt-1">
                    <!-- <button class="add-n">Add New Email ID</button> -->
                    <button class="btn-two" (click)="DataMISReport()">Download</button>
                  </div>
                </form>



                 <form class="staff-form mt-2" *ngIf="selectedCard === 'Call Performance MIS'">
                  <div class="row">
                    <div class="col-lg-12 col-xs-12 col-sm-6">
                      <div class="form-group">
                        <!-- <label>Perfomance Report</label> -->
                        <!-- <select class="select-al"    [ngModelOptions]="{standalone: true}" 
                                                [(ngModel)]="status">
                                                  <option value="teleCallerPerfomance MISReport">TeleCaller Perfomance</option>
                                                  <option value="Perfomance MISReport">Perfomance Report</option>
                                                 </select> -->
                      </div>

                      <div class="form-group">
                        <label>Users </label>
                        <ng-multiselect-dropdown [settings]="dropdownSettings" [ngModelOptions]="{standalone: true}"
                          [(ngModel)]="selectUser" [data]="users">
                        </ng-multiselect-dropdown>
                      </div>

                   
                    </div>
                    <div class="col-lg-12 col-xs-12 col-sm-6">
                      <div class="form-group">
                        <label>From Date*</label>
                        <input type="date" [ngModelOptions]="{standalone: true}" [(ngModel)]="fromDate"
                          class="form-control" placeholder="Type here">
                      </div>
                      <div class="form-group">
                        <label>To Date*</label>
                        <input type="date" [ngModelOptions]="{standalone: true}" [(ngModel)]="toDate"
                          class="form-control" placeholder="Type here">
                      </div>
                    </div>
                    <!-- <div class="col-lg-12 col-xs-12 col-sm-6">
                                            <div class="form-group">
                                              <label>Email ID*</label>
                                              <input type="text" class="form-control" placeholder="Type here">
                                            </div>
                                            </div> -->
                  </div>
                  <div class="content mt-1">
                    <!-- <button class="add-n">Add New Email ID</button> -->
                    <button class="btn-two" (click)="report1()">Download</button>
                  </div>
                </form>

                
                 <form class="staff-form mt-2" *ngIf="selectedCard === 'Email Count MIS'">
                  <div class="row">
                    <div class="col-lg-12 col-xs-12 col-sm-6">
                      <div class="form-group">
                        <!-- <label>Perfomance Report</label> -->
                        <!-- <select class="select-al"    [ngModelOptions]="{standalone: true}" 
                                                [(ngModel)]="status">
                                                  <option value="teleCallerPerfomance MISReport">TeleCaller Perfomance</option>
                                                  <option value="Perfomance MISReport">Perfomance Report</option>
                                                 </select> -->
                      </div>

                      <div class="form-group">
                        <label>Users </label>
                        <ng-multiselect-dropdown [settings]="dropdownSettings" [ngModelOptions]="{standalone: true}"
                          [(ngModel)]="selectUser" [data]="users">
                        </ng-multiselect-dropdown>
                      </div>

                   
                    </div>
                    <div class="col-lg-12 col-xs-12 col-sm-6">
                      <div class="form-group">
                        <label>From Date*</label>
                        <input type="date" [ngModelOptions]="{standalone: true}" [(ngModel)]="fromDate"
                          class="form-control" placeholder="Type here">
                      </div>
                      <div class="form-group">
                        <label>To Date*</label>
                        <input type="date" [ngModelOptions]="{standalone: true}" [(ngModel)]="toDate"
                          class="form-control" placeholder="Type here">
                      </div>
                    </div>
                    <!-- <div class="col-lg-12 col-xs-12 col-sm-6">
                                            <div class="form-group">
                                              <label>Email ID*</label>
                                              <input type="text" class="form-control" placeholder="Type here">
                                            </div>
                                            </div> -->
                  </div>
                  <div class="content mt-1">
                    <!-- <button class="add-n">Add New Email ID</button> -->
                    <button class="btn-two" (click)="report1()">Download</button>
                  </div>
                </form>


                <!-- 
                                <div class="footer-section1">
                                    <button><img src="../../assets/images/plus-blue.png">Add New Staff</button>

                                </div> -->
                <div class="footer-section2">

                  <img src="../../assets/images/accruon-footer (2).png">
                </div>

              </div>

            </div>

          </div>

        </div>


      </main>

    </div>
  </div>


</body>